import { Box } from '@mui/material';
import ExoAvatar from '../../exo/ExoAvatar';
import LabeledBox from '../../special/LabeledBox';
import ExoDialog from '../../exo/ExoDialog';
import { useState } from 'react';
import SelectLeadCompanies from '../../select/SelectLeadCompanies';

const TypeLeadCompanies = ({
  updateValidationOnChange,
  dataCollection,
  errors,
  field,
  size,
  noPreview,
}) => {
  const [open, setOpen] = useState(false);

  const companies = dataCollection[field.key];

  function handleSelect(element) {
    updateValidationOnChange(field.key, element);
  }

  return (
    <>
      <LabeledBox
        label={field.label}
        className="w-full"
        onClick={() => setOpen(true)}
        size={size}
      >
        {!noPreview &&
          companies?.map((company) => (
            <Box className="flex items-center gap-2">
              <ExoAvatar
                name={company.nameShort || company.name}
                size="30px"
                type={'contact'}
              />
              {company.nameShort || company.name}
            </Box>
          ))}
      </LabeledBox>
      <ExoDialog open={open} onClose={() => setOpen(false)} limitWidth>
        <SelectLeadCompanies onSelect={handleSelect} preSelected={companies} />
      </ExoDialog>
    </>
  );
};

export default TypeLeadCompanies;
